<template lang="html">
  <div class="worker-list" v-if="this.cityname">
    <!-- <p v-if="cityname !== '' && list.length > 0">{{cityname}}</p> -->
    <listFilter
      v-on:doSearch="searchData"
      v-if="citycode !== ''"
      :citycode="citycode"
      :cityname="cityname"
    >
    </listFilter>
    <loadData
      viewName="allWorkerList"
      :fetchData="list"
      :fetchMethod="getWorker"
      :controlPage="changePage"
      :page="pageIndex"
      :pageSize="pageSize"
      :firstFetch="firstFetch"
      :hasErr="hasErr"
      :otherParams="{
        errText: '该区域暂无对应服务人员<br/>敬请期待',
        cityname: cityname,
        errImg: img
      }"
    />
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import loadData from '@/components/loadMore'
import listFilter from '@/components/work/list-filter'
import config from '@/plugins/config'

export default {
  data() {
    return {
      pageIndex: 1,
      pageSize: 10,
      list: [],
      firstFetch: true,
      hasErr: false,
      cityname: '',
      serviceType: 1,
      // gbcode: '320100',
      citycode: '320100',
      startLevels: '',
      areaCodes: '',
      appoitDay: '',
      img: require('../../assets/images/empty1.png'),
      provinceLevelCity: [110000, 120000, 310000, 500000],
      category: ''
    }
  },
  async created() {
    this.serviceType = this.$route.params.serviceType || '1'
    const city = this.$$cookie('city_service') || ''
    let code = ''
    let name = ''
    if (city && city.includes('_')) {
      code = city.split('_')[0]
      name = city.split('_')[1]
      this.citycode = code || this.$route.query.citycode || '320100'
      this.cityname = name || this.$route.query.cityname
    } else {
      this.citycode = this.$route.query.citycode || '320100'
      this.cityname = this.$route.query.cityname
      const citycode_h5 = this.$$cookie('citycode_h5') || ''
      if (citycode_h5) {
        this.citycode = citycode_h5
        this.cityname = ''
      }
    }

    if (!this.cityname) {
      const res = await this.$store.dispatch('getNameById', {
        addressId: this.citycode
      })
      this.cityname = res.NAME
    }
    if (this.provinceLevelCity.includes(this.citycode * 1)) {
      this.citycode = this.citycode - 0 + 100
    }
    this.category = this.$route.query.category || ''
    this.title = '服务人员列表'
    if (!this.category) {
      this.getWorker()
    }
    this.getServiceCateList()
    this.$$title(this.title)
    this.$$loading(false)
  },
  mounted() {
    this.$$allowRefreshOrShare(false, true)
  },
  methods: {
    ...mapMutations(['setFilterService']),
    searchData() {
      this.pageIndex = 1
      this.firstFetch = true
      this.hasErr = false
      this.getWorker()
    },
    async getWorker() {
      try {
        if (this.pageIndex === 1) {
          // this.$store.commit('reSetWorkers')
          this.list.length = 0
          this.list = []
        }
        const workerlist = await this.$store.dispatch('getWorkersByCondition', {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          cityId: this.citycode,
          districtIds: this.serverArea.map(val => val.ID),
          categoryIds: this.filterService.map(val => val.categoryId)
        })
        if (workerlist.length > 0) {
          this.list.push(...(workerlist || []))
        }
        this.firstFetch = false
      } catch (e) {
        this.firstFetch = false
        // this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    },
    async getServiceCateList() {
      await this.$store.dispatch('getServiceCateList')
      if (this.category) {
        const filterCategory = this.serviceTypeList.filter(
          v => v.categoryId * 1 === this.category * 1
        )
        if (filterCategory && filterCategory.length > 0) {
          this.setFilterService(filterCategory)
        }
      }
    },
    changePage(pageIndex) {
      this.pageIndex = pageIndex
    }
  },
  components: {
    loadData,
    listFilter
  },
  computed: {
    ...mapState([
      'workerList',
      'serverArea',
      'filterCity',
      'filterArea',
      'filterLevel',
      'filterTime',
      'filterService',
      'starLevelsList',
      'serviceTypeList',
      'serverArea',
      'serviceTypeList'
    ]),
    askType() {
      return this.$route.query.type || '2'
    }
  }
}
</script>
<style lang="scss">
#vproduct_app {
  background-color: #fff;
}
</style>
<style lang="scss" scoped>
@import '../../assets/css/mixin';
.worker-list {
  > p {
    padding-left: rem(20px);
    line-height: rem(80px);
    background: #fff;
    font-size: rem(28px);
    @include border(bottom);
  }
}
</style>
